import { fn } from '@ember/helper';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { eq } from 'ember-truth-helpers';
import SettingsBudgetForecastSegmentHierarchyItem from 'lumen/components/settings/budget-forecast/segment-hierarchy/item';
import type { BudgetForecastSegment } from 'lumen/models';

interface SettingsBudgetForecastSegmentHierarchyColumnSignature {
  Args: {
    depth: number;
    expandedSegment: BudgetForecastSegment | null;
    onExpandSegment: (segment: BudgetForecastSegment) => void;
    onToggleSegmentCheckbox: (segment: BudgetForecastSegment) => void;
    segments: BudgetForecastSegment[];
  };
}

export default class SettingsBudgetForecastSegmentHierarchyColumn extends Component<SettingsBudgetForecastSegmentHierarchyColumnSignature> {
  @service declare intl: Services['intl'];

  get title(): string {
    switch (this.args.depth) {
      case 2:
        return this.intl.t('settings.central_mapping.hierarchy.sub_categories');
      case 1:
        return this.intl.t('settings.central_mapping.hierarchy.categories');
      default:
        return this.intl.t('settings.central_mapping.hierarchy.groups');
    }
  }

  <template>
    <div data-test-id="segment-hierarchy-column">
      <h3
        class="text-200--bold border-neutral-default border-b border-solid px-400 py-200"
        data-test-id="segment-hierarchy-column-title"
        id="column-title-{{@depth}}"
      >
        {{this.title}}
      </h3>

      <ul aria-labelledby="column-title-{{@depth}}" role="tree">
        {{#each @segments as |segment|}}
          <SettingsBudgetForecastSegmentHierarchyItem
            @isChecked={{segment.visible}}
            @isExpanded={{eq segment.id @expandedSegment.id}}
            @onExpandSegment={{fn @onExpandSegment segment}}
            @onToggleSegmentCheckbox={{fn @onToggleSegmentCheckbox segment}}
            @segment={{segment}}
          />
        {{/each}}
      </ul>
    </div>
  </template>
}
